export default "__VITE_ASSET__wzEbgSAo__"